import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useSidebar } from "@/components/ui/sidebar";

/**
 * When the route changes on viewports where the sidebar is a sheet
 * (same breakpoint as `useIsMobile`, below `md`), closes the drawer so the new
 * page is visible.
 */
export function SidebarMobileCloseOnRouteChange() {
  const { pathname, search } = useLocation();
  const { isMobile, setOpenMobile } = useSidebar();

  useEffect(() => {
    if (isMobile) {
      setOpenMobile(false);
    }
  }, [pathname, search, isMobile, setOpenMobile]);

  return null;
}
